import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type AccountHeroProps = {
  className?: string
  greeting: string
  name: string
}

function AccountHero({ className, greeting, name }: AccountHeroProps) {
  const gridStyle = useStyle({
    grid: GlobalGridPreset.BASE_GRID,
  })

  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title30_40SangBleu,
    color: GlobalThemeColors.Black,
  })

  return (
    <section className={cx(className, css.AccountHero, gridStyle)}>
      <div className={css.wrapper}>
        <span className={titleStyle}>
          {greeting}
          {name ? `, ${name}` : ''}
        </span>
      </div>
    </section>
  )
}

AccountHero.defaultProps = {}

export default AccountHero
